import { Configuration } from './types';

export const config: Partial<Configuration> = {
  portalApi: 'https://ewa.api.preflight.portal.genvis.com/v1',
  mapbox: {
    defaultStyle: 'mapbox://styles/robgenvis/cmizqxrq9006201r81qml3b97',
    satelliteStyle: 'mapbox://styles/robgenvis/cmizqz3k4006301sn591b269u',
    overlaysTileSet: 'mapbox://robgenvis.ewa-overlays-dev',
    overlayTileSetLayers: {
      dfesRegions: 'dfes-regions-tileset-layer-dev',
      lga: 'lga-tileset-layer-dev',
      lgaCentres: 'lga-centres-tileset-layer-dev',
      pastoralStations: 'pastoral-stations-tileset-layer-dev',
      fdrRegions: 'fdr-regions-tileset-layer-dev',
      fdrCenters: 'fdr-centres-tileset-layer-dev',
    },
  },
  remoteHazardAssets: {
    iconAssetsPathSvg: 'https://preflight.kudo.genvis.com/assets/icons/map/pins',
    iconAssetsPathPng: 'https://preflight.kudo.genvis.com/assets/icons/map/pins/40x40',
  },
  // TODO target the correct (preflight) bucket when ready
  geospatialBucket: 'https://dbqyqh98zsjbu.cloudfront.net',
  webTemplateStyleSheetUrl: 'https://preflight.kudo.genvis.com/assets/styles/ewa-webtemplate.css',
  sentry: {
    dsn: 'https://cf40a211f5f4e6805072722487e2373b@o4507253793816576.ingest.de.sentry.io/4507255077339216',
  },
  environment: 'preflight',
};
